import React, { Component } from "react";
import PropTypes from "prop-types";
import Svg from "react-svg-inline";
import styles from "./index.module.css";

import PrimaryButton from "../PrimaryButton";
import HomeAnimation from "../HomeAnimation";

import logoAtomico from "./logoAtomico.svg";
import logoSlush from "./logoSlush.svg";
import logoOrrick from "./logoOrrick.svg";
import logoSvb from "./logoSvb.svg";
import keyboardArrows from "./keyboardArrows.svg";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = { animationReady: false };
    this.onAnimationReady = this.onAnimationReady.bind(this);
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line
    console.log("Error loading Home component", error, info);
  }

  componentDidMount() {
    // push section details into state so we can use them in the nav
    this.props.setNavSection(false, "Home");
  }

  onAnimationReady() {
    this.setState({ animationReady: true });
  }

  render() {
    const { chapterPath, onDownloadClick, skipAnimation } = this.props;
    const { animationReady } = this.state;

    return (
      <div className={styles.root}>
        <div className={styles.keyboardArrows}>
          <Svg
            className={styles.keyboardArrowsImage}
            svg={keyboardArrows}
            height="50px"
          />
        </div>
        <div className={styles.inner}>
          <div className={styles.attribution}>
            <div className={styles.atomicoLogo}>
              <a
                href="http://atomico.com"
                className={styles.logoLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Svg
                  className={styles.atomicoLogoImage}
                  svg={logoAtomico}
                  alt="Atomico Logo"
                />
              </a>
            </div>
            <div className={styles.spacer}>
              <span className={styles.spacerText}>In collaboration with</span>
            </div>
            <div className={styles.slushLogo}>
              <a
                href="http://www.slush.org"
                className={styles.logoLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Svg
                  className={styles.slushLogoImage}
                  svg={logoSlush}
                  alt="Slush logo"
                />
              </a>
            </div>
            <div className={styles.presentsText}>presents</div>
          </div>

          <div className={styles.header}>
            <div className={styles.year}>
              <span className={styles.yearText}>2017</span>
            </div>
            <h1 className={styles.title}>
              The State of{" "}
              <span className={styles.titleInner}>European Tech</span>
            </h1>
          </div>

          <nav className={styles.nav}>
            <div className={styles.navItem}>
              <PrimaryButton to={chapterPath} type="link">
                Explore the data
              </PrimaryButton>
            </div>
            <div className={styles.navItem}>
              <PrimaryButton onClick={onDownloadClick} inverted={true}>
                Download Report
              </PrimaryButton>
            </div>
          </nav>

          <div className={styles.supporters}>
            <div className={styles.spacer}>
              <span className={styles.spacerText} style={{ color: "#abacd3" }}>
                Supported by
              </span>
            </div>
            <ul className={styles.supporterList}>
              <li className={styles.supporterItem}>
                <a
                  href="https://www.orrick.com/"
                  className={styles.logoLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Svg
                    className={styles.orrickLogoImage}
                    svg={logoOrrick}
                    alt="Orrick logo"
                    width="69px"
                  />
                </a>
              </li>
              <li className={styles.supporterItem}>
                <a
                  href="https://www.svb.com/uk/"
                  className={styles.logoLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Svg
                    className={styles.svbLogoImage}
                    svg={logoSvb}
                    alt="SVB logo"
                    width="71px"
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
        {skipAnimation ? null : (
          <div className={styles.animWrapper}>
            <div
              className={animationReady ? styles.animBgReady : styles.animBg}
            />
            <HomeAnimation
              className={styles.anim}
              onReady={this.onAnimationReady}
            />
          </div>
        )}
      </div>
    );
  }
}

/* <div className={animationReady ? styles.animBgReady : styles.animBg} />; */

Home.defaultProps = {
  skipAnimation: false
};

Home.propTypes = {
  chapterPath: PropTypes.string.isRequired,
  onDownloadClick: PropTypes.func,
  setNavSection: PropTypes.func,
  skipAnimation: PropTypes.bool
};

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home/index.js